import {
    DEFAULT_ACCESS_ENABLED,
    DEFAULT_ACCESS_RULES,
    DEFAULT_LIMITS_ENABLED,
    DEFAULT_LIMIT_POLICY,
    DEFAULT_LIMITS_STATE
} from '../configuration.constants';

/**
 * Setters owned by the Limits tab. Persistent state (limit_policy,
 * limits_enabled, access_rules, access_enabled) lives on the controller's
 * internal `state`.
 */
class LimitsDelegate {
    setLimitPolicy(limitPolicy) {
        this.setState({ limit_policy: limitPolicy || DEFAULT_LIMIT_POLICY });
    }

    setLimitPolicyField(field, value) {
        this.setState((prev) => ({
            limit_policy: { ...prev.limit_policy, [field]: value }
        }));
    }

    setLimitsEnabled(limitsEnabled) {
        this.setState({
            limits_enabled: {
                maxAdvances: limitsEnabled?.maxAdvances ?? DEFAULT_LIMITS_ENABLED.maxAdvances,
                advanceAmounts: limitsEnabled?.advanceAmounts ?? DEFAULT_LIMITS_ENABLED.advanceAmounts,
                totalVolume: limitsEnabled?.totalVolume ?? DEFAULT_LIMITS_ENABLED.totalVolume,
                feeCap: limitsEnabled?.feeCap ?? DEFAULT_LIMITS_ENABLED.feeCap
            }
        });
    }

    toggleLimitsSection(sectionKey) {
        this.setState((prev) => ({
            limits_enabled: {
                ...prev.limits_enabled,
                [sectionKey]: !prev.limits_enabled?.[sectionKey]
            }
        }));
    }

    setAccessRules(accessRules) {
        this.setState({ access_rules: accessRules || DEFAULT_ACCESS_RULES });
    }

    setAccessRulesField(field, value) {
        this.setState((prev) => ({
            access_rules: { ...prev.access_rules, [field]: value }
        }));
    }

    setAccessEnabled(accessEnabled) {
        this.setState({
            access_enabled: {
                negativeBalance: accessEnabled?.negativeBalance ?? DEFAULT_ACCESS_ENABLED.negativeBalance,
                overdraftNsf: accessEnabled?.overdraftNsf ?? DEFAULT_ACCESS_ENABLED.overdraftNsf,
                loansOverdue: accessEnabled?.loansOverdue ?? DEFAULT_ACCESS_ENABLED.loansOverdue
            }
        });
    }

    /** UI only — which adjustments tab a cap card shows. */
    setCapRuleTab(cap, tabKey) {
        this.setState((prev) => ({
            // Defaults first: a Cancel restores a snapshot without cap_rule_tabs.
            cap_rule_tabs: { ...DEFAULT_LIMITS_STATE.cap_rule_tabs, ...prev.cap_rule_tabs, [cap]: tabKey }
        }));
    }

    toggleAccessRule(ruleKey) {
        this.setState((prev) => ({
            access_enabled: {
                ...prev.access_enabled,
                [ruleKey]: !prev.access_enabled?.[ruleKey]
            }
        }));
    }
}

export default LimitsDelegate;
